import SgdfWatchingCount from './watching-count.component.js';
export * from './watching-count.component.js';
export default SgdfWatchingCount;
SgdfWatchingCount.define('sgdf-watching-count');
//# sourceMappingURL=watching-count.js.map